export const FORM_FIELD = {
  LOCATION_NAME: {
    name: 'name',
    label: 'Location name:',
    placeholder: 'Enter a location name',
    rules: [{ required: true, message: 'Location name is required' }],
  },
  LATITUDE: {
    name: 'latitude',
    label: 'Latitude:',
    placeholder: 'Enter a latitude',
    rules: [
      { required: true, message: 'Latitude is required' },
      { type: 'number', message: 'This field must be a number.' },
    ],
  },
  LONGITUDE: {
    name: 'longitude',
    label: 'Longitude:',
    placeholder: 'Enter a longitude',
    rules: [
      { required: true, message: 'Longitude is required' },
      { type: 'number', message: 'This field must be a number.' },
    ],
  },
};
